import moment from 'moment';
import { GetterTree } from 'vuex';
import { IComment } from '@signing-page/chat/types/comment';
import { IRootState } from '@signing-page/store/store';
import { IChatState } from '@signing-page/chat/store/chat.store';
import { IDocumentState } from '@signing-page/documents/store/document.types';
import { IRecipient } from '@signing-page/documents/types/recipient';
import { IParticipant } from '@signing-page/chat/types/participant';
import { IChatMessage } from '@signing-page/chat/types/chat-message';
import { IUser } from '@signing-page/users/types/user';

export const getters: GetterTree<IChatState, IRootState> = {
  participants: (state: IChatState, getters: any, rootState: IRootState): IParticipant[] => {
    const documentState: IDocumentState = rootState['document'];
    const { user, recipients } = documentState.document;
    return [user, ...recipients].map((participant: IUser | IRecipient) => ({
      imageUrl: participant.thumbUrl,
      name: participant.fullName,
      id: participant.id,
    }));
  },
  messages: (state: IChatState, getters: any, rootState: IRootState): IChatMessage[] => {
    const id: string = rootState.recipientId;
    return state.comments.map((comment: IComment) => {
      const recipientId: string = id === comment.recipientId ? 'me' : comment.recipientId;

      return {
        type: 'text',
        author: `${comment.userId || recipientId}`,
        data: {
          text: comment.commentText,
          meta: moment(comment.createdAt).format('LLL'),
        },
      };
    });
  },
  numUnreadComments: (state: IChatState, getters: any, rootState: IRootState): number => {
    let othersComments: IComment[];
    if (rootState.recipientId) {
      othersComments = state.comments.filter((comment: IComment) => {
        return comment.recipientId !== rootState.recipientId;
      });
    } else {
      othersComments = state.comments;
    }

    const commentsReadIds: string[] = state.commentsRead
      ? state.commentsRead.map((comment: IComment) => comment.id)
      : [];

    return othersComments.filter((comment: IComment) => {
      return !commentsReadIds.includes(comment.id);
    }).length;
  },
};
